/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Notes_Notes_PlaceholderInputs */

const en_event_notes_notes_placeholder = /** @type {(inputs: Event_Notes_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter notes...`)
};

const fr_event_notes_notes_placeholder = /** @type {(inputs: Event_Notes_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez des notes...`)
};

const de_event_notes_notes_placeholder = /** @type {(inputs: Event_Notes_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notizen eingeben...`)
};

const it_event_notes_notes_placeholder = /** @type {(inputs: Event_Notes_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci le note...`)
};

const ru_event_notes_notes_placeholder = /** @type {(inputs: Event_Notes_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите примечания...`)
};

const es_event_notes_notes_placeholder = /** @type {(inputs: Event_Notes_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introducir notas...`)
};

const zh_cn2_event_notes_notes_placeholder = /** @type {(inputs: Event_Notes_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入备注……`)
};

const ja_event_notes_notes_placeholder = /** @type {(inputs: Event_Notes_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メモを入力してください...`)
};

const hi_event_notes_notes_placeholder = /** @type {(inputs: Event_Notes_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नोट्स लिखें...`)
};

const pt_pt2_event_notes_notes_placeholder = /** @type {(inputs: Event_Notes_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insira notas...`)
};

/**
* | output |
* | --- |
* | "Enter notes..." |
*
* @param {Event_Notes_Notes_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_notes_notes_placeholder = /** @type {((inputs?: Event_Notes_Notes_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Notes_Notes_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_notes_notes_placeholder(inputs)
	if (locale === "de") return de_event_notes_notes_placeholder(inputs)
	if (locale === "it") return it_event_notes_notes_placeholder(inputs)
	if (locale === "ru") return ru_event_notes_notes_placeholder(inputs)
	if (locale === "es") return es_event_notes_notes_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_event_notes_notes_placeholder(inputs)
	if (locale === "ja") return ja_event_notes_notes_placeholder(inputs)
	if (locale === "hi") return hi_event_notes_notes_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_event_notes_notes_placeholder(inputs)
	return en_event_notes_notes_placeholder(inputs)
});